import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import {
  ButtonSkeleton,
  CaptionSkeleton,
  DetailsSkeleton,
  InputSkeleton,
  TextSkeleton,
} from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';
import {
  ApplicationInfoLoading,
  FeeInfoLoading,
  MaturityInfoLoading,
  NetValueInfoLoading,
  ProfitabilityInfoLoading,
  RiskInfoLoading,
  TaxInfoLoading,
  UnitPriceInfoLoading,
} from '../shared';

export const ListLoadingItemMobile: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  return (
    <TableContent direction="row" space={0} p={0} px="inline.xxxs">
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding="inset.sm" space="stack.xxxs" w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <TextSkeleton w="35%" />
          <DetailsSkeleton />
        </HStack>
        <HStack justifyContent="space-between" alignItems="center">
          <HStack space="inline.nano">
            <CaptionSkeleton />
            <CaptionSkeleton />
            <CaptionSkeleton />
          </HStack>
          <RiskInfoLoading w="45%" />
        </HStack>
        <HStack justifyContent="space-between">
          <ApplicationInfoLoading w="45%" />
          <MaturityInfoLoading w="45%" />
        </HStack>
        <HStack justifyContent="space-between">
          <TaxInfoLoading w="45%" />
          <UnitPriceInfoLoading w="45%" />
        </HStack>
        <HStack justifyContent="space-between">
          <Stack w="45%">
            <HStack space="inline.quarck" alignItems="center">
              <UI.Text>Taxa</UI.Text>
              <UI.Text fontSize="xs">(Spread)</UI.Text>
            </HStack>
            <InputSkeleton />
          </Stack>
          <ProfitabilityInfoLoading w="45%" />
        </HStack>
        <HStack justifyContent="space-between">
          <FeeInfoLoading w="45%" />
          <NetValueInfoLoading w="45%" />
        </HStack>
        <HStack space="inline.xxxs" justifyContent="space-between" w="full">
          <VStack space="stack.quarck" w="75%">
            <UI.Text color="neutral.black" variant="semibold">
              Aplicação mínima:
            </UI.Text>
            <InputSkeleton />
          </VStack>
          <Stack alignSelf="flex-end" w="20%">
            <ButtonSkeleton borderRadius={BoxBorder.thick} />
          </Stack>
        </HStack>
      </VStack>
    </TableContent>
  );
};
